import script from "./OrganizationContracts.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationContracts.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationContracts.vue?vue&type=style&index=0&id=78df8ede&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78df8ede"]])

export default __exports__